import { Injectable } from '@angular/core';
import { DataListModel } from '../models/data-list-model';
import { Observable, of } from 'rxjs';
import { RoleService } from './role.service';
import { HttpClient } from '@angular/common/http';
import { EmailReminder } from '../dto/email-reminder';

@Injectable({
  providedIn: 'root'
})
export class PaymentEmailRemindersService {
  readonly apiPath = 'email-reminders/';
    constructor(
      private http: HttpClient,
      private roleService: RoleService,
    ) { }
    getRemindersByOrder(id: number): Observable<DataListModel<EmailReminder>> {
      if (this.roleService.hasRoles('admin')) {
        return this.http.get(this.apiPath + 'order/' + id) as Observable<DataListModel<EmailReminder>>;
      }
      return of(new DataListModel<EmailReminder>(null, 0));
    }
    getRemindersByDistribution(id: string): Observable<DataListModel<EmailReminder>> {
      if (this.roleService.hasRoles('admin')) {
        return this.http.get(this.apiPath + 'distribution/' + id) as Observable<DataListModel<EmailReminder>>;
      }
      return of(new DataListModel<EmailReminder>(null, 0));
    }
}
